import { createTheme } from "@material-ui/core/styles";
import createBreakpoints from "@material-ui/core/styles/createBreakpoints";

// Generate breakpoints so we can use them in the theme definition
const breakpoints = createBreakpoints({});

export default createTheme({
  overrides: {
    MuiPaper: {
      root: {
        "@media print": {
          border: "1px solid #dbdbdb",
          boxShadow: "none !important"
        }
      }
    }
  },
  palette: {
    primary: {
      dark: "#1226aa",
      light: "#75aef1",
      main: "#4a90e2"
    },
    secondary: {
      light: "#e89861",
      main: "#ef6d13"
    },
    type: "light"
  },
  typography: {
    body1: {
      color: "#707070",
      [breakpoints.down("sm")]: {
        fontSize: "1.2rem"
      },
      [breakpoints.up("md")]: {
        fontSize: "1.6rem"
      }
    },
    body2: {
      color: "#4e4e4e",
      [breakpoints.down("sm")]: {
        fontSize: "1.2rem"
      },
      [breakpoints.up("md")]: {
        fontSize: "1.4rem"
      },
      fontWeight: 400
    },
    caption: {
      color: "#909090",
      [breakpoints.down("sm")]: {
        fontSize: "1.4rem"
      },
      [breakpoints.up("md")]: {
        fontSize: "1.6rem"
      },
      fontWeight: 400
    },
    fontFamily: "Open Sans, Helvetica, Arial, sans-serif",
    fontSize: 16,
    h1: {
      [breakpoints.up("md")]: {
        fontSize: "4.5rem"
      },
      color: "#707070",
      fontSize: "3.0rem",
      fontWeight: 700
    },
    h2: {
      color: "#545454",
      [breakpoints.down("sm")]: {
        fontSize: "2.0rem"
      },
      [breakpoints.up("md")]: {
        fontSize: "3.2rem"
      },
      fontWeight: 600
    },
    h3: {
      color: "#545454",
      [breakpoints.down("sm")]: {
        fontSize: "1.6rem"
      },
      [breakpoints.up("md")]: {
        fontSize: "2.4rem"
      },
      fontWeight: 600,
      margin: "0 0 8px"
    },
    h4: {
      [breakpoints.up("md")]: {
        fontSize: "2rem"
      },
      color: "#707070",
      fontSize: "1.8rem",
      fontWeight: 600
    },
    htmlFontSize: 10,
    subtitle1: {
      [breakpoints.down("sm")]: {
        fontSize: "1.2rem"
      },
      [breakpoints.up("md")]: {
        fontSize: "1.6rem"
      },
      color: "#707070",
      fontWeight: 600
    },
    subtitle2: {
      [breakpoints.down("sm")]: {
        fontSize: "1.2rem"
      },
      [breakpoints.up("md")]: {
        fontSize: "1.6rem"
      },
      fontWeight: 600
    }
  }
});
